export default __webpack_public_path__ + "static/images/404.127285d5.jpg";